import React from 'react'

const Background = ({ children }: { children: React.ReactNode }) => (
  <div className="w-[300px] h-[358px] bg-[rgba(255,255,255,0.67)] absolute z-50 rounded-b bottom-0">
    {children}
  </div>
)

export default Background
